import { render } from "./LycgList.vue?vue&type=template&id=6bbd70be"
import script from "./LycgList.vue?vue&type=script&lang=js"
export * from "./LycgList.vue?vue&type=script&lang=js"

import "./LycgList.vue?vue&type=style&index=0&id=6bbd70be&lang=css"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__